// El Boletin Alpha.
//
// Vivia en `lib/api.js` junto con otros veintidos apartados (R4.5). Quien lo importa
// no se entero: `@/lib/api` sigue exportando exactamente lo mismo.
import { api } from "./client";

// ---- Boletín Alpha (Newsletter) ----

export const getNewsletters = () =>
  api.get("/newsletter").then((r) => r.data.newsletters);
export const getNewsletter = (slug) =>
  api.get(`/newsletter/${slug}`).then((r) => r.data);
// admin
export const adminListNewsletters = () =>
  api.get("/admin/newsletter").then((r) => r.data.newsletters);
export const adminGetNewsletter = (id) =>
  api.get(`/admin/newsletter/${id}`).then((r) => r.data);
export const adminCreateNewsletter = (payload) =>
  api.post("/admin/newsletter", payload).then((r) => r.data);
export const adminUpdateNewsletter = (id, payload) =>
  api.patch(`/admin/newsletter/${id}`, payload).then((r) => r.data);
export const adminDeleteNewsletter = (id) =>
  api.delete(`/admin/newsletter/${id}`).then((r) => r.data);
export const adminPreviewNewsletter = (payload) =>
  api.post("/admin/newsletter/preview", payload).then((r) => r.data);
export const adminSendNewsletter = (id) =>
  api.post(`/admin/newsletter/${id}/send`).then((r) => r.data);
export const adminSendNewsletterNow = (payload) =>
  api.post("/admin/newsletter/send-now", payload).then((r) => r.data);
